"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NCPDP_ERROR_CODE_MAP = void 0;
exports.NCPDP_ERROR_CODE_MAP = {
    '01': 'Missing or Invalid: BIN Number',
    '02': 'Missing or Invalid: NCPDP Version Number',
    '03': 'Missing or Invalid: Transaction Code',
    '04': 'Missing or Invalid: Processor Control Number (PCN)',
    '05': 'Missing or Invalid: Pharmacy Number (NPI)',
    '06': 'Missing or Invalid: Group Number',
    '07': 'Missing or Invalid: Cardholder ID Number',
    '08': 'Missing or Invalid: Person Code',
    '09': 'Missing or Invalid: Birth Date',
    '12': 'Missing or Invalid: Patient Location Code',
    '13': 'Missing or Invalid: Other Coverage Code',
    '14': 'Missing or Invalid: Eligibility Verification Code',
    '15': 'Missing or Invalid: Date of Service',
    '16': 'Missing or Invalid: RX Number',
    '17': 'Missing or Invalid: Fill Number',
    '19': 'Missing or Invalid: Days Supply',
    '20': 'Missing or Invalid: Compound Code',
    '21': 'Missing or Invalid: National Drug Code (NDC)',
    '22': 'Missing or Invalid: Dispense as Written (DAW) Code',
    '23': 'Missing or Invalid: Ingredient Cost',
    '25': 'Missing or Invalid: Prescriber ID (NPI)',
    '26': 'Missing or Invalid: Unit of Measure',
    '28': 'Missing or Invalid: Prescription Date',
    '29': 'Maximum number of refills has been reached',
    '32': 'Missing or Invalid: Level of Service',
    '33': 'Missing or Invalid: Prescription Origin Code',
    '34': 'Missing or Invalid: Submission Clarification Code',
    '35': 'Missing or Invalid: Primary Care Provider ID',
    '38': 'Missing or Invalid: Basis Of Cost',
    '39': 'Missing or Invalid: Diagnosis Code (ICD10)',
    '40': 'Pharmacy not contracted with plan on date of service',
    '41': 'Submit bill to other processor or primary payer',
    '50': 'Billing provider ID not on file',
    '51': 'Non-Matched Group ID',
    '52': 'Non-Matched Cardholder ID',
    '53': 'Non-Matched Person Code',
    '54': 'National Drug Code (NDC) not on file',
    '55': 'Non-Matched Product Package Size',
    '56': 'Prescribing physician license number not on file',
    '58': 'Non-Matched Primary Prescriber',
    '60': 'Product/Service Not Covered For Patient Age',
    '61': 'National Drug Code (NDC) not covered for patient\'s gender',
    '62': 'Patient/Card Holder ID Name Mismatch',
    '63': 'Institutionalized Patient Product/Service ID Not Covered',
    '64': 'Claim Submitted Does Not Match Prior Authorization',
    '65': 'Patient is not covered',
    '66': 'National Drug Code (NDC) is inconsistent with the patient\'s age',
    '67': 'Filled Before Coverage Effective',
    '68': 'Filled After Coverage Expired',
    '69': 'Filled After Coverage Terminated',
    '70': 'National Drug Code (NDC) is not covered',
    '71': 'Prescriber Is Not Covered',
    '72': 'Primary Prescriber Is Not Covered',
    '73': 'Refills Are Not Covered',
    '74': 'Other Carrier Payment Meets Or Exceeds Payable',
    '75': 'Prior Authorization Required',
    '76': 'Plan Limitations Exceeded',
    '77': 'Discontinued Product/Service ID Number',
    '78': 'Cost Exceeds Maximum',
    '79': 'Refill too soon',
    '80': 'National Drug Code (NDC) requires manual review unless there is an Eligibility Clarification Code',
    '81': 'Claim is past filing limit',
    '82': 'Billing date is before date of service',
    '83': 'A duplicate claim has already been submitted',
    '84': 'Claim has not been paid',
    '85': 'Claim Not Processed',
    '86': 'Submit Manual Reversal',
    '87': 'Reversal not processed',
    '88': 'DUR Reject Error',
    '89': 'Rejected Claim Fees Paid',
    '90': 'Host Hung Up',
    '91': 'Host Response Error',
    '92': 'System Unavailable/Host Unavailable',
    '95': 'Time Out',
    '96': 'Scheduled Downtime',
    '97': 'Payer Unavailable',
    '98': 'Connection To Payer Is Down',
    '99': 'Host processing error',
    '1C': 'Missing or Invalid:Smoker/Non-Smoker Code',
    '1E': 'Missing or Invalid:Prescriber Location Code',
    '10': 'Missing or Invalid:Patient Gender Code',
    '11': 'Missing or Invalid:Patient Relationship Code',
    '2C': 'Missing or Invalid: Pregnancy Indicator',
    '2E': 'Missing or Invalid: Primary Care Provider ID Qualifier',
    '3A': 'Missing or Invalid: Request Type',
    '3B': 'Missing or Invalid: Request Period Date-Begin',
    '3C': 'Missing or Invalid: Request Period Date-End',
    '3D': 'Missing or Invalid: Basis Of Request',
    '3E': 'Missing or Invalid: Authorized Representative First Name',
    '3F': 'Missing or Invalid: Authorized Representative Last Name',
    '3G': 'Missing or Invalid: Authorized Representative Street Address',
    '3H': 'Missing or Invalid: Authorized Representative City Address',
    '3J': 'Missing or Invalid: Authorized Representative State/Province Address',
    '3K': 'Missing or Invalid: Authorized Representative Zip/Postal Zone',
    '3M': 'Missing or Invalid: Prescriber Phone Number',
    '3N': 'Missing or Invalid: Prior Authorized Number Assigned',
    '3P': 'Missing or Invalid: Authorization Number',
    '3R': 'Prior Authorization Not Required',
    '3S': 'Missing or Invalid: Prior Authorization Supporting Documentation',
    '3T': 'Active Prior Authorization Exists Resubmit At Expiration Of Prior Authorization',
    '3W': 'Prior Authorization In Process',
    '3X': 'Authorization Number Not Found',
    '3Y': 'Prior Authorization Denied',
    '4C': 'Missing or Invalid: Coordination of Benefits (COB)',
    '4E': 'Missing or Invalid: Primary Care Provider Last Name',
    '5C': 'Missing or Invalid: Other Payer Coverage Type',
    '5E': 'Missing or Invalid: Other Payer Reject Count',
    '6C': 'Missing or Invalid: Other Payer ID Qualifier',
    '6E': 'Missing or Invalid: Other Payer Reject Code',
    '7C': 'Missing or Invalid: Other Payer ID',
    '7E': 'Missing or Invalid: DUR/PPS Code Counter',
    '8C': 'Missing or Invalid: Facility ID',
    '8E': 'Missing or Invalid: DUR/PPS Level Of Effort',
    '8R': 'Submission clarification code not supported',
    'A5': 'Not Covered Under Part D Law',
    'A7': 'Missing or Invalid: Other Payer Internal Control Number (ICN)',
    'A9': 'Missing or Invalid: Transaction Count',
    'AA': 'Patient Spenddown Not Met',
    'AB': 'Date dispensed is before date prescribed',
    'AC': 'Product Not Covered Non-Participating Manufacturer',
    'AD': 'Billing provider is not eligible to bill this claim type',
    'AE': 'QMB (Qualified Medicare Beneficiary)-Bill Medicare',
    'AF': 'Patient Enrolled Under Managed Care',
    'AG': 'Days Supply Limitation For Product/Service',
    'AH': 'Unit Dose Packaging Only Payable For Nursing Home Recipients',
    'AJ': 'Generic Drug Required',
    'AK': 'Missing or Invalid: Software Vendor Certification ID',
    'AM': 'Missing or Invalid: Segment Identification',
    'B2': 'Missing or Invalid: Service Provider ID Qualifier',
    'BE': 'Missing or Invalid: Professional Service Fee Submitted',
    'CA': 'Missing or Invalid: Patient First Name',
    'CB': 'Missing or Invalid: Patient Last Name',
    'CC': 'Missing or Invalid: Cardholder First Name',
    'CD': 'Missing or Invalid: Cardholder Last Name',
    'CE': 'Missing or Invalid: Home Plan',
    'CF': 'Missing or Invalid: Employer Name',
    'CG': 'Missing or Invalid: Employer Street Address',
    'CH': 'Missing or Invalid: Employer City Address',
    'CI': 'Missing or Invalid: Employer State/Province Address',
    'CJ': 'Missing or Invalid: Employer Zip Postal Zone',
    'CK': 'Missing or Invalid: Employer Phone Number',
    'CL': 'Missing or Invalid: Employer Contact Name',
    'CM': 'Missing or Invalid: Patient Street Address',
    'CN': 'Missing or Invalid: Patient City Address',
    'CO': 'Missing or Invalid: Patient State/Province Address',
    'CP': 'Missing or Invalid: Patient Zip/Postal Zone',
    'CQ': 'Missing or Invalid: Patient Phone Number',
    'CR': 'Missing or Invalid: Carrier ID',
    'CW': 'Missing or Invalid: Alternate ID',
    'CX': 'Missing or Invalid: Patient ID Qualifier',
    'CY': 'Missing or Invalid: Patient ID',
    'CZ': 'Missing or Invalid: Employer ID',
    'DN': 'Missing or Invalid: Basis of Cost Determination',
    'DQ': 'Missing or Invalid: Usual and Customary Charge',
    'DR': 'Missing or Invalid: Prescriber Last Name',
    'DT': 'Missing or Invalid: Unit Dose Indicator',
    'DU': 'Missing or Invalid: Gross Amount Due',
    'DV': 'Missing or Invalid: Other Payer Amount Paid',
    'DX': 'Missing or Invalid: Patient Paid Amount',
    'DY': 'Missing or Invalid: Date Of Injury',
    'DZ': 'Missing or Invalid: Claim/Reference ID',
    'E1': 'Missing or Invalid: Product/Service ID Qualifier',
    'E3': 'Missing or Invalid: Incentive Amount Submitted',
    'E4': 'Missing or Invalid: Reason for Service Code',
    'E5': 'Missing or Invalid: Professional Service Code',
    'E6': 'Missing or Invalid: Result of Service Code',
    'E7': 'Missing or Invalid: Quantity Dispensed',
    'E8': 'Missing or Invalid: Other Payer Date',
    'E9': 'Missing or Invalid: Provider ID',
    'EA': 'Missing or Invalid: Originally Prescribed Product/Service Code',
    'EB': 'Missing or Invalid: Originally Prescribed Quantity',
    'EC': 'Missing or Invalid: Compound Ingredient Count',
    'ED': 'Missing or Invalid: Compound Ingredient Quantity',
    'EE': 'Missing or Invalid: Compound Ingredient Drug Cost',
    'EF': 'Missing or Invalid: Compound Dosage Form Description Code',
    'EG': 'Missing or Invalid: Compound Dispensing Unit Form Indicator',
    'EH': 'Missing or Invalid: Compound Route of Administration',
    'EJ': 'Missing or Invalid: Originally Prescribed Product/Service ID Qualifier',
    'EK': 'Missing or Invalid: Scheduled Prescription ID Number',
    'EM': 'Missing or Invalid: RX Number Qualifier',
    'EN': 'Missing or Invalid: Associated Prescription/Service Reference Number',
    'EP': 'Missing or Invalid: Associated Prescription/Service Date',
    'ER': 'Missing or Invalid: Procedure Modifier Code',
    'ET': 'Missing or Invalid: Quantity Prescribed',
    'EU': 'Missing or Invalid: Prior Authorization Type Code',
    'EV': 'Missing or Invalid: Prior Authorization Number Submitted',
    'EW': 'Missing or Invalid: Intermediary Authorization Type ID',
    'EX': 'Missing or Invalid: Intermediary Authorization ID',
    'EY': 'Missing or Invalid: Provider ID Qualifier',
    'EZ': 'Missing or Invalid: Prescriber ID Qualifier',
    'FO': 'Missing or Invalid: Plan ID',
    'GE': 'Missing or Invalid: Percentage Sales Tax Amount Submitted',
    'H1': 'Missing or Invalid: Measurement Time',
    'H2': 'Missing or Invalid: Measurement Dimension',
    'H3': 'Missing or Invalid: Measurement Unit',
    'H4': 'Missing or Invalid: Measurement Value',
    'H6': 'Missing or Invalid: DUR Co-Agent ID',
    'H7': 'Missing or Invalid: Other Amount Claimed Submitted Count',
    'H8': 'Missing or Invalid: Other Amount Claimed Submitted Qualifier',
    'H9': 'Missing or Invalid: Other Amount Claimed Submitted',
    'HA': 'Missing or Invalid: Flat Sales Tax Amount Submitted',
    'HB': 'Missing or Invalid: Other Payer Amount Paid Count',
    'HC': 'Missing or Invalid: Other Payer Amount Paid Qualifier',
    'HD': 'Missing or Invalid: Dispensing Status',
    'HE': 'Missing or Invalid: Percentage Sales Tax Rate Submitted',
    'HF': 'Missing or Invalid: Quantity Intended To Be Dispensed',
    'HG': 'Missing or Invalid: Days Supply Intended To Be Dispensed',
    'JE': 'Missing or Invalid: Percentage Sales Tax Basis Submitted',
    'J9': 'Missing or Invalid: DUR Co-Agent ID Qualifier',
    'KE': 'Missing or Invalid: Coupon Type',
    'M1': 'The patient\'s category is not eligible for non-medicare covered services',
    'M2': 'Patient is locked in to a specific provider',
    'M3': 'Host PA/MC Error',
    'M4': 'Refill on invoice is older than 6 months',
    'M5': 'A manual review is required to verify the age of this patient',
    'M6': 'Host Eligibility Error',
    'M7': 'Host Drug File Error',
    'M8': 'Host Provider File Error',
    'ME': 'Missing or Invalid: Coupon Number',
    'MZ': 'Error Overflow',
    'NE': 'Missing or Invalid: Coupon Value Amount',
    'NN': 'Transaction Rejected At Switch Or Intermediary',
    'P1': 'Associated Prescription/Service Reference Number Not Found',
    'P2': 'Clinical Information Counter Out Of Sequence',
    'P3': 'Submitted compound ingredient count does not match the actual count',
    'P4': 'Other payer count does not match actual count',
    'P5': 'Coupon Expired',
    'P6': 'Date Of Service Prior To Date Of Birth',
    'P7': 'Submitted diagnosis count does not match actual count',
    'P8': 'Invalid DUR/PPS code counter',
    'PA': 'PA Exhausted/Not Renewable',
    'PB': 'Invalid Transaction Count For This Transaction Code',
    'PC': 'Missing or Invalid: Claim Segment Identifier',
    'PD': 'Missing or Invalid: Clinical Segment Identifier',
    'PE': 'Missing or Invalid: Other Payer Segment Identifier',
    'PF': 'Missing or Invalid: Compound Segment Identifier',
    'PG': 'Missing or Invalid: Coupon Segment',
    'PH': 'Missing or Invalid: DUR/PPS Segment Identifier',
    'PJ': 'Missing or Invalid: Insurance Segment Identifier',
    'PK': 'Missing or Invalid: Patient Segment Identifier',
    'PM': 'Missing or Invalid: Pharmacy Provider Segment',
    'PN': 'Missing or Invalid: Prescriber Segment Identifier',
    'PP': 'Missing or Invalid: Pricing Segment Identifier',
    'PR': 'Missing or Invalid: Prior Authorization Segment',
    'PS': 'Missing or Invalid: Transaction Header Segment',
    'PT': 'Missing or Invalid: Workers Compensation Segment',
    'PV': 'Non-Matched Associated Prescription/Service Date',
    'PW': 'Non-Matched Employer ID',
    'PX': 'Non-Matched Other Payer ID',
    'PY': 'Non-Matched Unit Form/Route of Administration',
    'PZ': 'Non-Matched Unit Of Measure To Product/Service ID',
    'R1': 'Other Amount Claimed Submitted Count Does Not Match Number Of Repetitions',
    'R2': 'Other Payer Reject Count Does Not Match Number Of Repetitions',
    'R3': 'Procedure Modifier Code Count Does Not Match Number Of Repetitions',
    'R4': 'Procedure Modifier Code Invalid For Product/Service ID',
    'R5': 'Product/Service ID Must Be Zero When Product/Service ID Qualifier Equals 06',
    'R6': 'Product/Service Not Appropriate For This Location',
    'R7': 'Repeating Segment Not Allowed In Same Transaction',
    'R8': 'Syntax Error',
    'R9': 'Value In Gross Amount Due Does Not Follow Pricing Formulae',
    'RA': 'PA Reversal Out Of Order',
    'RB': 'Multiple Partials Not Allowed',
    'RC': 'Different Drug Entity Between Partial & Completion',
    'RD': 'Mismatched Cardholder/Group ID-Partial To Completion',
    'RE': 'Missing or Invalid: Compound Produce ID Qualifier',
    'RF': 'Improper Order Of "Dispensing Status Code" On Partial Fill Transaction',
    'RG': 'Missing or Invalid: Associated Prescription/Service Reference Number On Completion Transaction',
    'RH': 'Missing or Invalid: Associated Prescription/Service Date On Completion Transaction',
    'RJ': 'Associated Partial Fill Transaction Not On File',
    'RK': 'Partial Fill Transaction Not Supported',
    'RM': 'Completion Transaction Not Permitted With Same "Date Of Service" As Partial Transaction',
    'RN': 'Plan Limits Exceeded On Intended Partial Fill Values',
    'RP': 'Out Of Sequence "P" Reversal On Partial Fill Transaction',
    'RS': 'Missing or Invalid: Associated Prescription/Service Date On Partial Transaction',
    'RT': 'Missing or Invalid: Associated Prescription/Service Reference Number On Partial Transaction',
    'RU': 'Mandatory Data Elements Must Occur Before Optional Data Elements In A Segment',
    'SE': 'Missing or Invalid: Procedure Modifier Code Count',
    'TE': 'Missing or Invalid: Compound Product ID',
    'UE': 'Missing or Invalid: Compound Ingredient Basis Of Cost Determination',
    'UI': 'Missing or Invalid: Compound Ingredient Basis of Cost Determination',
    'VE': 'Missing or Invalid: Diagnosis Code Count',
    'WE': 'Missing or Invalid: Diagnosis Code Qualifier',
    'XE': 'Missing or Invalid: Clinical Information Counter',
    'ZE': 'Missing or Invalid: Measurement Date',
    '569': 'Provide Notice: Medicare Prescription Drug Coverage and Your Rights',
};



//////////////////
// WEBPACK FOOTER
// ./src/shared/erx/errors.ts
// module id = 2792
// module chunks = 0